import Fab from '@mui/material/Fab';
import { useNavigate } from 'react-router-dom';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import useCartStore from '@/stores/cart.store';
import { formatMoney } from '@/utils/Utils';
import useCreateOrder from '@/hooks/use-create-order';
import { useOrderQuery } from '@/hooks/queries/use-order-query';
import useGlobalStore from '@/stores/global.store';
import { OrderValidationStatus } from '@/types/api/order/order-validation-status.enum';
import useModalStore from '@/stores/modal.store';

const purple = {
  50: '#854a94',
  100: '#9b6aa7',
  200: '#b08aba',
  300: '#c6aacd',
  400: '#dbcae0',
  500: '#702a81',
  600: '#682778',
  700: '#60246f',
  800: '#582166',
  900: '#511e5d',
  950: '#491b54',
};

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
};

const fabStyle = {
  position: 'fixed',
  bottom: 24,
  right: 24,
  color: 'common.white',
  bgcolor: purple[500],
  '&:hover': {
    bgcolor: purple[600],
  },
  fontFamily: "'Outfit', sans-serif",
  height: 56,
  minHeight: 56,
  paddingX: 3,
  fontSize: '1.05rem',
  fontWeight: 600,
  borderRadius: 999,
};

const fab = {
  color: 'inherit',
  sx: { ...fabStyle },
  label: 'Expand',
};

const CheckoutFab = () => {
  const orderId = useGlobalStore((state) => state.orderId);
  const modalType = useModalStore((state) => state.type);
  const { data: order } = useOrderQuery(orderId!);
  const total = useCartStore((state) => state.totalPrice);
  const items = useCartStore((state) => state.items);
  const { create } = useCreateOrder();

  return (
    <Fab
      disabled={
        Boolean(modalType) || order?.validationStatus === OrderValidationStatus.Pending || !Boolean(items.length)
      }
      sx={fab.sx}
      variant="extended"
      color="primary"
      onClick={() => create()}
    >
      <ShoppingCartIcon sx={{ mr: 1, fontSize: '1.5rem' }} />
      Beställ ({formatMoney(total)})
    </Fab>
  );
};

export default CheckoutFab;
